import { Component, Input } from '@angular/core';

@Component({
    selector: 'features-mobile',
    templateUrl: './features.mobile.component.html',
    styleUrls: ['./features.mobile.component.scss']
})
export class FeaturesMobileComponent {
    @Input() model: any;
    @Input() sheet: boolean = false;
}
